import React, { useState } from 'react';
import axios from 'axios';
import {
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonPage,
  IonButtons,
  IonMenuButton,
  IonRow,
  IonCol,
  IonButton,
  IonList,
  IonItem,
  IonInput,
  IonText,
} from '@ionic/react';
import './Login.scss';
import { setIsLoggedIn, setUsername } from '../data/user/user.actions';
import { connect } from '../data/connect';
import { RouteComponentProps } from 'react-router';

interface OwnProps extends RouteComponentProps {}

interface DispatchProps {
  setIsLoggedIn: typeof setIsLoggedIn;
  setUsername: typeof setUsername;
}

interface LoginProps extends OwnProps, DispatchProps {}

const Login: React.FC<LoginProps> = ({
  setIsLoggedIn,
  history,
  setUsername: setUsernameAction,
}) => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [cpassword, setCPassword] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [usernameError, setUsernameError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [cpasswordError, setCPasswordError] = useState(false);
  const [registerError, setRegisterError] = useState('');
  
  const validateEmail = (email: string) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const login = async (e: React.FormEvent) => {
    e.preventDefault();
    setFormSubmitted(true);
    if (!username) {
      setUsernameError(true);
      return;
    }
    if (!email || !validateEmail(email)) {
      setEmailError(true);
      return;
    }
    if (!password) {
      setPasswordError(true);
      return;
    }
    if (!cpassword || (password !== cpassword)) {
      setCPasswordError(true);
      return;
    }

    const apiUrl = process.env.REACT_APP_API_URL;
    
    if (username && password && cpassword && email) {
      try {
        const response = await axios.post(`${apiUrl}/register`, {
          name: username,
          email: email,
          password: password,
          c_password: cpassword,
        });

        if (response.status === 200) {
          // Handle success
          const token = response.data.data.token;
          localStorage.setItem('authToken', token);
          await setIsLoggedIn(true);
          await setUsernameAction(response.data.data.name);
          history.push('/tabs/store', { direction: 'none' });
        }
      } catch (error) {
        console.error('Error during registration:', error);
        setRegisterError("ユーザー登録に失敗しました。")
      }
    }
  };

  return (
    <IonPage id="signup-page">
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton></IonMenuButton>
          </IonButtons>
          <IonTitle>登　録</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div className="login-logo">
          <img src="assets/img/appicon.svg" alt="Ionic logo" />
        </div>
        {registerError && (
          <IonText color="danger" className="center-text">
            <p>{registerError}</p>
          </IonText>
        )}
        <form noValidate onSubmit={login}>
          <IonList>
            <IonItem>
              <IonInput
                label="ユーザー名"
                labelPlacement="stacked"
                color="primary"
                name="username"
                type="text"
                value={username}
                spellCheck={false}
                autocapitalize="off"
                onIonInput={(e) => {
                  setUsername(e.detail.value as string);
                  setUsernameError(false);
                }}
                required
              >
                {formSubmitted && usernameError && (
                  <IonText color="danger" slot="error">
                    <p>ユーザー名を入力してください。</p>
                  </IonText>
                )}
              </IonInput>
            </IonItem>

            <IonItem>
              <IonInput
                label="メールアドレス"
                labelPlacement="stacked"
                color="primary"
                name="email"
                type="email"
                value={email}
                spellCheck={false}
                autocapitalize="off"
                onIonInput={(e) => {
                  setEmail(e.detail.value as string);
                  setEmailError(false);
                }}
                required
              >
                {formSubmitted && emailError && (
                  <IonText color="danger" slot="error">
                    <p>有効なメールアドレスを入力してください。</p>
                  </IonText>
                )}
              </IonInput>
            </IonItem>

            <IonItem>
              <IonInput
                label="パスワード"
                labelPlacement="stacked"
                color="primary"
                name="password"
                type="password"
                value={password}
                onIonInput={(e) => {
                  setPassword(e.detail.value as string);
                  setPasswordError(false);
                }}
              >
                {formSubmitted && passwordError && (
                  <IonText color="danger" slot="error">
                    <p>パスワードを入力してください。</p>
                  </IonText>
                )}
              </IonInput>
            </IonItem>

            <IonItem>
              <IonInput
                label="パスワード確認"
                labelPlacement="stacked"
                color="primary"
                name="cpassword"
                type="password"
                value={cpassword}
                onIonInput={(e) => {
                  setCPassword(e.detail.value as string);
                  setCPasswordError(false);
                }}
              >
                {formSubmitted && cpasswordError && (
                  <IonText color="danger" slot="error">
                    <p>パスワードを再入力してください。</p>
                  </IonText>
                )}
              </IonInput>
            </IonItem>
          </IonList>

          <IonRow>
            <IonCol>
              <IonButton type="submit" expand="block">
                登　録
              </IonButton>
            </IonCol>
          </IonRow>
        </form>
      </IonContent>
    </IonPage>
  );
};

export default connect<OwnProps, {}, DispatchProps>({
  mapDispatchToProps: {
    setIsLoggedIn,
    setUsername,
  },
  component: Login,
});
